<template>
    <li
        :class="[buttonClasses, html != '&laquo;' && html != '&raquo;' ? 'page-number' : '']"
        :title="title"
        @click="pageChange"
    >
        <a
            class="page-link"
            v-html="html"
        />
    </li>
</template>

<script>
export default {
    name: 'PageButton',

    props: {
        page: {
            type: [
                Number,
                String,
            ],
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        html: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disableStyling: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        buttonClasses () {
            if (this.disableStyling)  {
                return {};
            }
            return {
                'page-item': true,
                'active': this.active,
                'disabled': this.disabled,
            };
        },
    },

    methods: {
        pageChange () {
            if (
                this.page === '...' ||
                this.disabled ||
                this.active
            ) {
                return;
            }

            this.$emit('page-change');
        },
    },
};
</script>
